import * as React from "react";
import ScrollBar from "react-perfect-scrollbar";
import { connect } from "react-redux";
import { IdPurchaseOfferGroup } from "../../../constants/IdPurchaseOfferGroup";
import { ScrollOptions } from "../../../constants/ScrollOptions";
import { IdStyles } from "../../../less/IdStyles";
import { selectGrantRewards } from "../../../selectors/selectShopInfo";
import { IdLoca } from "../../../utils/i18n/IdLoca";
import { ButtonPrimary } from "../../generic/common/ButtonPrimary";
import { TextLoca } from "../../generic/text/TextLoca";
import { actionModalCloseAll } from "../../modals/actionModal";
import { OfferRewardList } from "./OfferRewardList";
import { PaymentRewardsHeader } from "./PaymentRewardsHeader";
import { ShopDialogWrapper } from "./ShopDialogWrapper";
var _DialogPaymentRewards = function (_a) {
    var onCloseClick = _a.onCloseClick, offer = _a.offer, rewards = _a.rewards, goldRewardAmount = _a.goldRewardAmount, subscriptionBonusEnabled = _a.subscriptionBonusEnabled;
    if (offer == undefined) {
        return React.createElement(React.Fragment, null);
    }
    var isSmsOffer = offer.offerCharacteristicId === IdPurchaseOfferGroup.Sms;
    var title = isSmsOffer ? IdLoca.empty : offer.locaKeyTitle;
    var alternativeText = (React.createElement("div", { className: "w100 h100 flex flex--guts" },
        React.createElement(TextLoca, { id: IdLoca.purchaseOffer_purchaseReward_desc, className: IdStyles.TextBoldPrimary })));
    return (React.createElement(ShopDialogWrapper, { className: IdStyles.OfferPurchaseRewardBackground, title: IdLoca.purchaseOffer_purchaseReward_desc, onClose: onCloseClick },
        React.createElement(PaymentRewardsHeader, { title: title, totalGoldAmount: goldRewardAmount, offer: offer, needsTooltip: !isSmsOffer, subscriptionBonusEnabled: subscriptionBonusEnabled }),
        React.createElement(ScrollBar, { component: "div", options: ScrollOptions, className: "offer-body__reward-list w100" },
            React.createElement(OfferRewardList, { rewards: rewards, className: IdStyles.OfferPurchaseRewardListItem + " offer-reward-item", emptyListReplacement: alternativeText })),
        React.createElement("div", { className: "rewards-dialog-footer-container w100 flex flex--guts" },
            React.createElement(ButtonPrimary, { onClick: onCloseClick },
                React.createElement("div", { className: IdStyles.TextButtonHeading },
                    React.createElement(TextLoca, { className: IdStyles.TextButtonDefault, id: IdLoca.hooray }))))));
};
var mapDispatch = function (dispatch) { return ({
    onCloseClick: function () { return dispatch(actionModalCloseAll()); },
}); };
export var DialogPaymentRewards = connect(selectGrantRewards, mapDispatch)(_DialogPaymentRewards);



//////////////////
// WEBPACK FOOTER
// ./src/features/shop/components/DialogPaymentRewards.tsx
// module id = 2899
// module chunks = 3